












import UserComponent from './unit/user.vue';
import AddUser from '@/views/system/organization/user/unit/add.vue';
import SetRole from '@/views/system/organization/user/unit/setRole.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    UserComponent,
    AddUser,
    SetRole,
  },
})
export default class UserIndex extends Vue {
  flag = 1; // 控制显示的组件
  row: object = {}; // 传递一行的值
  setRoleFlag = false; // 传递给编辑和新增用户的： 分配角色是否显示
  roleData: object = {}; // 传递到分配角色和数据权限页面用户的数据
  contentFlag = false; // 判断是分配角色和还是数据权限内容
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  /**
   * @todo 后期需要优化的部分
   * @desc 自定义事件，user 组件中如果点击编辑和新增用户会触发。
   * @param1 row： 该行用户信息
   * @returns 返回值描述
   */
  setRow(row: object): void {
    this.row = row;
  }
  /**
   * @todo 后期需要优化的部分
   * @desc 设置 setRoleDate 的值。
   * @param1 data: user 这个子组件传递过来的值。
   * @returns 暂无
   */
  setRoleData(data: any): void {
    this.roleData = data.row;
    this.contentFlag = data.flag;
  }
}
